const createSuspensionClockEvent = () => [
  { action: "newEventId", value: null, type: "main" },
  { action: "saveData", value: "clock", type: "class" },
  { action: "saveData", value: "suspension", type: "eventType" },
  { action: "saveData", value: "adjust", type: "subType" },
  {
    action: "saveData",
    value: [{ option: "value", value: "2" }],
    type: "options",
  },
  { action: "sendEvent", value: "new", type: "main" },
  { action: "copyEvent", value: "card-clock", type: "to" },
];

const createGoalEventActionGroup = () => [
  {
    actions: [
      { action: "newEvent", value: null, type: "main" },
      { action: "clearData", value: ["personId"], type: "main" },
      { action: "saveData", value: [], type: "options" },
      { action: "saveData", value: "sevenMetrePenalty", type: "subType" },
      { action: "saveData", value: "goal", type: "eventType" },
      { action: "copyEvent", value: "penalty-shot", type: "to" },

    ],
    conditions: [
      {
        item: "eventDefined",
        value: "penalty-shot",
        operator: "not",
      },
    ]
  },
  {
    actions: [
      { action: "copyEvent", value: "penalty-shot", type: "from" }
    ],
    conditions: [
      {
        item: "eventDefined",
        value: "penalty-shot",
        operator: "is",
      },
    ]
  },
]

export const PenaltySuspension = {
  name: "penalty-suspension-type",
  component: "MainPanel",
  layout: "main-panel large padded align-center",
  mode: "visible",
  text: "suspension.type.select",
  showOn: [{ state: "primary", value: "penalty-suspension", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  allowBack: { value: "useHistory" },
  children: [
    {
      name: "pre-action",
      component: "PreAction",
      layout: "pre-action",
      mode: "enable",
      text: "",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "clearData", value: ["subType", "personId", "options"] },
            { action: "clearEvent", value: "penalty-shot" },
            { action: "clearEvent", value: "penalty-suspension" },
            { action: "clearEvent", value: "penalty-suspension-two-min-1" },
            { action: "clearEvent", value: "penalty-suspension-two-min-2" },
            { action: "clearEvent", value: "card-clock-start" },
            { action: "deleteFromPlay", value: "redCard", type: "main" },
            { action: "deleteFromPlay", value: "yellowCard", type: "main" },
            { action: "deleteFromPlay", value: "blueCard", type: "main" },
            { action: "deleteFromPlay", value: "suspension", type: "main", class: "sport", options: ["all"] },
            { action: "deleteFromPlay", value: "suspension", type: "main", class: "clock", options: ["all"] },
          ],
          conditions: [],
        },
      ],
    },

    {
      name: "suspension-buttons",
      component: "ButtonPanel",
      layout: "button-group centered",
      mode: "visible",
      showOn: [true],
      children: [
        {
          name: "2min-suspension",
          component: "TypeButton",
          layout: "type-button",
          mode: "enable",
          text: "suspension.2min",
          showOn: [true],
          actionGroups: [
            ...createGoalEventActionGroup(),
            {
              actions: [
                { action: "clearData", value: ["subType", "personId", "options"] },
                { action: "newEventId", value: null, type: "main" },
                { action: "saveData", value: "suspension", type: "eventType" },
                { action: "saveData", value: "twoMinutes", type: "subType" },
                { action: "clearData", value: ["personId"], type: "main" },
                { action: "sendEvent", value: "new", type: "main" },
                { action: "copyEvent", value: "penalty-suspension", type: "to" },
                ...createSuspensionClockEvent(),
                { action: "stopClock", value: "stop", type: "main" },
                { action: "copyEvent", value: "penalty-suspension", type: "from" },
                {
                  action: "nextState",
                  value: "penalty-suspension-player",
                  type: "primary",
                },

                { action: "processInserts", value: "all", type: "inserts" },
              ],
              conditions: [],
            },
          ],
          startEvent: false,
          startPlay: false,
        },
        {
          name: "4min-suspension",
          component: "TypeButton",
          layout: "type-button",
          mode: "enable",
          text: "suspension.4min",
          showOn: [true],
          actionGroups: [
            ...createGoalEventActionGroup(),
            {
              actions: [
                { action: "copyEvent", value: "penalty", type: "to" },
                { action: "clearData", value: ["subType", "personId", "options"] },

                { action: "newEvent", value: null, type: "main" },
                { action: "saveData", type: "eventType", value: "suspension" },
                { action: "saveData", type: "subType", value: "twoMinutes" },
                { action: "clearData", value: ["personId"], type: "main" },
                { action: "sendEvent", value: "new", type: "main" },
                { action: "copyEvent", value: "penalty-suspension-two-min-1", type: "to" },

                { action: "newEvent", value: null, type: "main" },
                { action: "saveData", type: "eventType", value: "suspension" },
                { action: "saveData", type: "subType", value: "twoMinutes" },
                { action: "sendEvent", value: "new", type: "main" },
                { action: "clearData", value: ["personId"], type: "main" },
                { action: "copyEvent", value: "penalty-suspension-two-min-2", type: "to" },

                { action: "copyEvent", value: "penalty-suspension", type: "to" },

                ...createSuspensionClockEvent(),
                { action: "stopClock", value: "stop", type: "main" },
                { action: "copyEvent", value: "penalty-suspension", type: "from" },
                {
                  action: "nextState",
                  value: "penalty-suspension-player",
                  type: "primary",
                },

                { action: "processInserts", value: "all", type: "inserts" },
              ],
              conditions: [],
            },
          ],
          startEvent: false,
          startPlay: false,
        },
      ],
    },
    {
      name: "card-buttons",
      component: "ButtonPanel",
      layout: "button-group centered",
      mode: "visible",
      showOn: [true],
      children: [
        {
          name: "yellow-card",
          component: "TypeButton",
          layout: "type-button yellowCard",
          mode: "enable",
          text: "yellowCard",
          showOn: [true],
          actionGroups: [
            ...createGoalEventActionGroup(),
            {
              actions: [
                { action: "clearData", value: ["subType", "personId", "options"] },
                { action: "newEventId", value: null, type: "main" },
                { action: "saveData", value: "yellowCard", type: "eventType" },
                { action: "copyEvent", value: "penalty-suspension", type: "to" },
                {
                  action: "nextState",
                  value: "penalty-suspension-player",
                  type: "primary",
                },
                { action: "processInserts", value: "all", type: "inserts" },
              ],
            },
          ],
        },
        {
          name: "red-card",
          component: "TypeButton",
          layout: "type-button redCard",
          mode: "enable",
          text: "redCard",
          showOn: [true],
          actionGroups: [
            ...createGoalEventActionGroup(),
            {
              actions: [
                { action: "copyEvent", value: "penalty", type: "to" },
                { action: "clearData", value: ["subType", "personId", "options"] },
                { action: "newEventId", value: null, type: "main" },
                { action: "saveData", value: "redCard", type: "eventType" },
                { action: "copyEvent", value: "penalty-suspension", type: "to" },
                {
                  action: "nextState",
                  value: "penalty-suspension-player",
                  type: "primary",
                },

                { action: "processInserts", value: "all", type: "inserts" },
              ],
            },
          ],
        },
        {
          name: "blue-card",
          component: "TypeButton",
          layout: "type-button blueCard",
          mode: "enable",
          text: "blueCard",
          showOn: [true],
          actionGroups: [
            ...createGoalEventActionGroup(),
            {
              actions: [
                { action: "copyEvent", value: "penalty", type: "to" },
                { action: "clearData", value: ["subType", "personId", "options"] },
                { action: "newEventId", value: null, type: "main" },
                { action: "saveData", value: "blueCard", type: "eventType" },
                { action: "copyEvent", value: "penalty-suspension", type: "to" },
                {
                  action: "nextState",
                  value: "penalty-suspension-player",
                  type: "primary",
                },

                { action: "processInserts", value: "all", type: "inserts" },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "extra-buttons",
      component: "ButtonPanel",
      layout: "button-group centered",
      mode: "visible",
      showOn: [true],
      children: [
        {
          name: "no-sanction",
          component: "TypeButton",
          layout: "type-button",
          mode: "enable",
          text: "no-sanction",
          showOn: [true],
          actionGroups: [
            ...createGoalEventActionGroup(),
            {
              actions: [
                { action: "deleteFromPlay", value: "yellowCard", type: "main"},
                { action: "deleteFromPlay", value: "blueCard", type: "main"},
                { action: "deleteFromPlay", value: "redCard", type: "main"},
                { action: "deleteFromPlay", value: "suspension", type: "main", class: "sport" },
                { action: "deleteFromPlay", value: "suspension", type: "main", class: "clock", options: ["all"] },
                {
                  action: "nextState",
                  value: "penalty-change-goal-keeper",
                  type: "primary",
                },
                { action: "processInserts", value: "all", type: "inserts" },
              ],
            },
          ],
          startEvent: false,
          startPlay: false,
        },
      ],
    },
  ],
};
